<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/3.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Refund and Cancellation Policy</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>Refund and Cancellation</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<!--section  -->
<section class="no-top-padding-sec" data-scrollax-parent="true">
    <div class="container">
        <div class="user-profile-header_content">
            <div class="ab_text-title fl-wrap">
                <h4>Refund and Cancellation Policy </h4>
                <span class="section-separator fl-sec-sep"></span>
            </div>
            <p>This refund and cancellation policy outlines how you can cancel or seek a refund for a product / service
                that you have purchased through the Platform. Under this policy:</p>

            <p>Cancellations will only be considered if the request is made 7 days of placing the order. However,
cancellation requests may not be entertained if the orders have been communicated to such sellers /
merchant(s) listed on the Platform and they have initiated the process of shipping them, or the
product is out for delivery. In such an event, you may choose to reject the product at the doorstep.</p>
            <p>Approved refund under the refund policy will be credited within 7 business working days to the original payment method.</p>
            <p>In case of receipt of damaged or defective items, please report to our customer service team. The
                request would be entertained once the seller/ merchant listed on the Platform, has checked and
                determined the same at its own end. This should be reported within 7 days of receipt of products.
                In case you feel that the product received is not as shown on the site or as per your expectations,
                you must bring it to the notice of our customer service within 7 days of receiving the product. The
                customer service team after looking into your complaint will take an appropriate decision.</p>
                <p>In case of complaints regarding the products that come with a warranty from the manufacturers,
                    please refer the issue to them.</p>
                    
            <p>Yes, the Consumer Protection Act of 2019 allows buyers to return defective, delayed, or mismatched items for a refund within 15 days of purchase. The items must be returned in their original packaging, undamaged, and without any size or form changes.</p>
            <p>If Shopping will provide the platform for buyers and sellers to interact and come to terms in case of any product returns. For any queries please mail us at <a href="mailto:support@businessinmaharashtra.com">support&#64;businessinmaharashtra.com</a> .</p>
            
        </div>
    </div>
</section>
<!--section end-->